import { render, staticRenderFns } from "./TetrisGame.vue?vue&type=template&id=7efabb1c&scoped=true"
import script from "./TetrisGame.vue?vue&type=script&lang=js"
export * from "./TetrisGame.vue?vue&type=script&lang=js"
import style0 from "./TetrisGame.vue?vue&type=style&index=0&id=7efabb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efabb1c",
  null
  
)

export default component.exports